import { Injectable, NgZone } from '@angular/core';
import { Platform, ToastController } from '@ionic/angular';
// import { SQLitePorter } from '@ionic-native/sqlite-porter/ngx';
import { HttpClient } from '@angular/common/http';
// import { SQLite, SQLiteObject } from '@ionic-native/sqlite/ngx';
import { BehaviorSubject, Observable } from 'rxjs';
import { config } from '../../app/helper/config';
import { Network } from '@ionic-native/network/ngx';
// import { BatteryStatus } from '@ionic-native/battery-status/ngx';
import { Geolocation, Geoposition, GeolocationOptions } from '@ionic-native/geolocation/ngx';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { async } from 'rxjs/internal/scheduler/async';
// import { BackgroundMode } from '@ionic-native/background-mode/ngx';
// import { NativeAudio } from '@ionic-native/native-audio/ngx';
import { filter, map, takeUntil, first } from 'rxjs/operators';
import { Subject } from 'rxjs';
// import { BackgroundGeolocation, BackgroundGeolocationConfig, BackgroundGeolocationEvents, BackgroundGeolocationResponse } from '@ionic-native/background-geolocation/ngx';
import { NativeGeocoder, NativeGeocoderResult, NativeGeocoderOptions } from '@ionic-native/native-geocoder/ngx';
import { rejects } from 'assert';
import { Location } from "../Location/location"
declare var navigator: any;


export interface LocationData {
  id: number,
  driver_id: any,
  latitude: any,
  longitude: any,
  date: any
}
export enum ConnectionStatus {
  Online,
  Offline
}
@Injectable({
  providedIn: 'root'
})
export class SqlDbseriveService {

  // public watch: any;
  // public lat: number = 0;
  // public lng: number = 0;
  // options: GeolocationOptions;
  // currentPos: Geoposition;
  // time: any;
  // address: string;
  // latitude1;
  // longitude1;
  // role_id;
  // currPosition;
  // trackedRoute = [];
  // private database: SQLiteObject;
  // private dbReady: BehaviorSubject<boolean> = new BehaviorSubject(false);
  // result = [];
  // batteryStatusfordevice;
  // networkType;
  // playSound;
  // trader_uid;
  // public unsubscriber$: Subject<any>;
  // ccids: any;
  // private status: BehaviorSubject<ConnectionStatus> = new BehaviorSubject(ConnectionStatus.Offline);
  // constructor(
  //   private plt: Platform,
  //   private sqlitePorter: SQLitePorter,
  //   private sqlite: SQLite,
  //   private http: HttpClient,
  //   private batteryStatus: BatteryStatus,
  //   private network: Network,
  //   public geoLocation: Geolocation,
  //   private diagnostic: Diagnostic,
  //   private nativeAudio: NativeAudio,
  //   public backgroundmode: BackgroundMode,
  //   // private backgroundGeolocation: BackgroundGeolocation,
  //   public zone: NgZone,
  //   private geolocation: Geolocation,
  //   private nativeGeocoder: NativeGeocoder,
  //   private toastController: ToastController,
  // ) {
  //   this.role_id = localStorage.getItem("role_id");
  //   console.log(this.backgroundmode.enable());
  //   let abc = this.backgroundmode.isEnabled();
  //   console.log(abc, "baclground mode");
  // }

  // async trackingFUnction(data, ccids) {
  //   console.log("tracking function required");
  //   console.log(ccids, 69);
  //   console.log(this.network, 127);
  //   this.trader_uid = data;
  //   this.ccids = JSON.stringify(ccids);
  //   this.nativeAudio.preloadSimple('laser', 'assets/Hen.mp3');
  //   // background fetch start
  //   let backgrnd = await this.startBackgroundFetch();
  //   let db = await this.sqlite.create({
  //     name: 'TrackingGPS.db',
  //     location: 'default'
  //   });
  //   this.database = db;
  //   this.seedDatabase();
  //   this.getLocationFromDevice();
  // }

  // seedDatabase() {
  //   this.http.get('assets/seed.sql', { responseType: 'text' })
  //     .subscribe(sql => {
  //       this.sqlitePorter.importSqlToDb(this.database, sql).then(_ => {
  //         this.dbReady.next(true);
  //       }).catch(e => {
  //         console.log(e)
  //       });
  //     });
  // }

  // getLocationFromDevice() {
  //   console.log("locate the device ");
  //   this.backgroundGeolocation.start();

  //   if (this.backgroundmode.isEnabled()) {
  //     console.log("background mode is enable");
  //   } else {
  //     console.log("background mode is disabled");
  //   }
  //   const config1: BackgroundGeolocationConfig = {
  //     desiredAccuracy: 10,
  //     stationaryRadius: 20,
  //     locationProvider:1,
  //     distanceFilter: 30,
  //     interval: 1000,
  //     debug: true, //  enable this hear sounds for background-geolocation life-cycle.
  //     stopOnTerminate: false, // enable this to clear background location settings when the app terminates
  //     saveBatteryOnBackground: true,
  //     startOnBoot: true,
  //     startForeground:false,
  //     pauseLocationUpdates: false,
  //   };
  //   this.backgroundGeolocation.configure(config1).then(async (data) => {
  //     console.log(data,137);
  //     this.backgroundGeolocation.on(BackgroundGeolocationEvents.location).subscribe(async (location: BackgroundGeolocationResponse) => {
  //       let bb = await this.getAddressFromCoords(location.latitude, location.longitude);
  //       console.log(bb);
  //       let aa = await this.batterystatus();
  //       // this.sendLocaltion(location.latitude, location.longitude, location.time);
  //       // this.sendLocaltion(this.trackedRoute);
  //       this.latitude1 = location.latitude;
  //       this.longitude1 = location.longitude;
  //       let exactDate = new Date(location.time);
  //       this.networkType = navigator.connection.type;;
  //       this.trackedRoute.push({
  //         latitude: this.latitude1,
  //         longitude: this.longitude1,
  //         addressloc: this.address,
  //         created_date: exactDate,
  //         statusBattery: this.batteryStatusfordevice,
  //         networkType: this.networkType,
  //         trader_uid: this.trader_uid,
  //         cc_uid: this.ccids
  //       });

  //       // this.http.post(config.api + 'driver/inserDriverRoute', this.trackedRoute).subscribe((data: any) => {
  //       this.http.post(config.api + 'driver/testRoute', this.trackedRoute).subscribe((data: any) => {
  //         console.log(data, 159);
  //         if (data.success) {
  //           this.trackedRoute = [];
  //         }
  //       }), ((error) => {
  //       });
  //     });
  //   }).catch((err) => {
  //     console.log(err);
  //   })
  //   // Turn ON the background-geolocation system.
  //   // this.backgroundGeolocation.start();
  // }

  // getAddressFromCoords(lattitude, longitude) {
  //   console.log("enter for address");
  //   return new Promise(async (resolve, reject) => {
  //     let options: NativeGeocoderOptions = {
  //       useLocale: true,
  //       maxResults: 5
  //     };
  //     this.nativeGeocoder.reverseGeocode(lattitude, longitude, options)
  //       .then((result: NativeGeocoderResult[]) => {
  //         this.address = "";
  //         let responseAddress = [];
  //         for (let [key, value] of Object.entries(result[0])) {
  //           if (value.length > 0)
  //             responseAddress.push(value);

  //         }
  //         responseAddress.reverse();
  //         for (let value of responseAddress) {
  //           this.address += value + ", ";
  //         }
  //         this.address = this.address.slice(0, -2);
  //         resolve(this.address);
  //       }, (err) => {
  //         reject(err);
  //       });
  //   }).catch((error: any) => {
  //     this.address = "Address Not Available!";
  //   });
  // }

  // batterystatus() {
  //   console.log("enter for battery");
  //   return new Promise(async (resolve, reject) => {
  //     console.log("hi");
  //     this.batteryStatus.onChange().subscribe((status) => {
  //       console.log(status);
  //       this.batteryStatusfordevice = status.level;
  //       console.log(this.batteryStatusfordevice);
  //       resolve(this.batteryStatusfordevice);
  //     }, (err) => {
  //       console.log(err, 179);
  //       reject(err);
  //     });
  //   }).catch((err) => {
  //     console.log(err);
  //   })

  // }

  // async sendLocaltion(data) {
  //   const networkState = navigator.connection.type;
  //   console.log(networkState, 256);
  // }

  // // Turn off the background-geolocation system.
  // stopgps() {
  //   this.backgroundGeolocation.stop();
  // }

  // startBackgroundFetch() {
  //   console.log("backGround fetch");
  //   this.backgroundmode.on("activate").subscribe((data: any) => {
  //     console.log('activated:', data);
  //     this.backgroundmode.moveToBackground();
  //     this.backgroundmode.isActive()
  //     console.log(this.backgroundmode.isActive(), 301);
  //   });
  //   this.backgroundmode.on('deactivate').subscribe((data) => {
  //     console.log('Deactivated:', data);
  //     this.backgroundmode.moveToForeground();
  //     console.log(this.backgroundmode.isActive(), 308);
  //   });
  // }
  // stopBackgroundFetch() {

  //   this.backgroundmode.disable();

  //   // this.backgroundmode.un("activate").subscribe((data) => {
  //   //   this.backgroundmode.disableWebViewOptimizations();
  //   // });
  // }
  // addLocation(data) {
  //   console.log(data, 222);
  //   return this.database.executeSql('INSERT INTO TrackingGPS(latitude, longitude, addressloc, created_date, statusBattery, trader_uid, cc_uid) VALUES(?, ?, ?, ?, ?, ?, ?)', [data[0].latitude, data[0].longitude, data[0].addressloc, data[0].created_date, data[0].statusBattery, data[0].trader_uid, data[0].cc_uid]).then(data => {
  //     console.log(data, 224);
  //     this.getLocation();
  //   }).catch(e => {
  //     console.log(e, 227);
  //   })
  // }

  // getLocation() {
  //   this.result = [];
  //   return this.database.executeSql('SELECT * FROM TrackingGPS', []).then(data => {
  //     for (let i = 0; i < data.rows.length; i++) {
  //       let item = data.rows.item(i);
  //       this.result.push(item);
  //       console.log(this.result, 196);
  //     }
  //   });
  // }

  // removeLocations() {
  //   return this.database.executeSql('DELETE FROM TrackingGPS where 1', []).then(data => {
  //     console.log(data, 202);
  //   });
  // }

  // updatePosition(position) {
  //   this.currPosition = position;
  // }

  // ngOnDestroy() {
  //   this.unsubscriber$.complete();
  // }

}